<template>
  <div class="center C888">
    <p class="vh18"></p>
    <img src="@/assets/img/empty3.png" alt="">
    <p class="opacity6 mt20 mb4">- 错误信息 -</p>
    <p class="size24 mb30 b500">{{ $route.query.msg || '错误页面哦' }}</p>
    <el-button type="primary" @click="$router.replace({ path: '/' })">回到首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'error',
  mounted () {}
}
</script>
